import { Component, OnInit, Input, AfterViewInit, Renderer2, ChangeDetectorRef, AfterContentChecked, OnDestroy } from '@angular/core';
import { fromEvent, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-character-counter',
  templateUrl: './character-counter.component.html',
  styleUrls: ['./character-counter.component.scss']
})
export class CharacterCounterComponent implements OnInit, AfterViewInit, AfterContentChecked, OnDestroy {
  input$: Observable<Event>;
  max: number;
  count: number;

  private ngUnsubscribe = new Subject();

  get remainingCount() {
    return this.max - this.count;
  }

  @Input()
  field: HTMLInputElement|HTMLTextAreaElement;

  @Input()
  display: 'inline' | 'block' = 'block';

  @Input()
  mode: 'count' | 'remaining' = 'count';

  constructor(
    private renderer: Renderer2, 
    private ref: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.count = 0;
    this.max = this.field.maxLength || 0;
  }

  ngAfterViewInit() {
    this.input$ = fromEvent(this.field, 'input');
    this.input$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        this.updateCount();
      });
  }

  ngAfterContentChecked() {
    this.updateCount();
  }
  
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  updateCount() {
    const updateCount = this.field.value.length;

    // Manual "dirty" check
    if (this.count !== updateCount) {
      this.count = updateCount;
      this.ref.markForCheck();
    }
  }  
}
